import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import CloseIcon from '../../../../../assets/icons/close.svg';
import {getCourseLabel} from '../../../../../utils/entity/course';
import {getYcLogoFile} from '../../../../../utils/entity/file';
import {Currency, getPriceString} from '../../../../../utils/money';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {course, membership, payment, program} = contexts;

  const data: EventData = {};

  if (payment) {
    if (payment.type === 'subscription') {
      data.avatar = getYcLogoFile(180);
      data.avatarPlaceholder = 'Your Coach';

      data.title = i18n.t(
        'notifications:payment_requires_action.subscription.title',
        {
          price: getPriceString({
            currency: Currency[payment.currency],
            price: payment.amount,
          }),
        },
      );
    } else if (payment.type === 'refund') {
      const courseLabel = getCourseLabel(course);

      data.avatar = program?.avatar;
      data.avatarPlaceholder = program?.title;

      data.title = i18n.t(
        'notifications:payment_requires_action.refund.title',
        {
          courseDates: courseLabel ? `(${courseLabel})` : '',
          courseTitle: program?.title,
          price: getPriceString({
            currency: Currency[payment.currency],
            price: payment.amount,
          }),
          userName: membership?.user_name,
        },
      );
    } else {
      data.avatar = program?.avatar;
      data.avatarPlaceholder = program?.title;

      data.title = i18n.t(
        'notifications:payment_requires_action.program.title',
        {
          courseTitle: program?.title,
          price: getPriceString({
            currency: Currency[payment.currency],
            price: payment.amount,
          }),
        },
      );
    }
  }

  data.icon = CloseIcon;
  data.iconGradient = 'danger';

  return data;
};
